<div class="fb-grid">
  <section class="card fb-excluded">
    <div class="fb-h">
      <div><h3>Why these are irrelevant</h3><p>Your reasons teach the agent what to leave out next time.</p></div>
      <span class="pill">{{ excluded.length }}</span>
    </div>

    <ng-container *ngIf="excluded.length; else noneExcluded">
      <div class="fb-item" *ngFor="let d of excluded; trackBy: trackById" [attr.data-doc]="d.id">
        <div class="t">
          <df-file-badge [ext]="d.ext"></df-file-badge>
          <div style="min-width:0">
            <b>{{ d.name }}</b>
            <div class="d-path">{{ docTypes[d.t].short }} · {{ landscapeLabel(d.land) }}</div>
          </div>
          <span style="flex:1"></span>
          <button type="button" class="link undo" (click)="undo(d.id)">Undo</button>
        </div>
        <div class="given" [class.none]="!df.reasons[d.id] && !df.whys[d.id]">
          <b>Feedback:</b>
          <ng-container *ngIf="df.reasons[d.id] || df.whys[d.id]; else noFeedback">
            <span class="r" *ngIf="df.reasons[d.id]">{{ df.reasons[d.id] }}</span>
            <span class="w" *ngIf="df.whys[d.id]">“{{ df.whys[d.id] }}”</span>
          </ng-container>
          <ng-template #noFeedback>none yet.</ng-template>
        </div>
      </div>
    </ng-container>
    <ng-template #noneExcluded>
      <div class="empty">You have not marked anything irrelevant.<br><button type="button" class="link" (click)="backToReview()">Go back to review</button></div>
    </ng-template>

    <ng-container *ngIf="pending.length">
      <div class="fb-h" style="border-top:1px solid var(--line)">
        <div><h3>Still undecided</h3><p>These will be left out of the pack unless you mark them relevant.</p></div>
        <span class="pill warn">{{ pending.length }}</span>
      </div>
      <div class="pend-list">
        <df-doc-row *ngFor="let d of pending; trackBy: trackById" [doc]="d" [compact]="true"></df-doc-row>
      </div>
    </ng-container>
  </section>

  <section class="card fb-missing">
    <div class="fb-h">
      <div><h3>Add Additional Custom Documents/Business Scenarios</h3><p>Users can upload or select additional business scenarios/documents.</p></div>
      <button type="button" class="btn sm add-missing" (click)="addMissing()"><df-icon name="plus" [size]="14"></df-icon>Add</button>
    </div>
    <div style="padding:6px 20px 18px">
      <ng-container *ngIf="df.missing.length; else noneMissing">
        <div class="miss-card" *ngFor="let m of df.missing; let i = index">
          <div class="t">
            <b style="font-size:13.5px">{{ m.title || 'Untitled document' }}</b>
            <span style="display:flex;gap:10px">
              <button type="button" class="link edit-missing" (click)="editMissing(i)">Edit</button>
              <button type="button" class="link remove-missing" style="color:#9B1026" (click)="removeMissing(i)">Remove</button>
            </span>
          </div>
          <dl class="kv">
            <dt>Type</dt><dd>{{ docTypes[m.type].short }} · {{ landscapeLabel(m.land, true) }}</dd>
            <dt>Process</dt><dd>{{ m.l2 }}{{ m.l3 ? ' · ' + m.l3 : '' }}</dd>
            <ng-container *ngIf="m.attachment as attachment">
              <dt>Attachment</dt><dd>{{ attachment.name }} · Uploaded; not yet searchable. Use Edit to download.</dd>
            </ng-container>
            <ng-container *ngIf="m.loc"><dt>Where it lives</dt><dd>{{ m.loc }}</dd></ng-container>
            <ng-container *ngIf="m.owner"><dt>Owner</dt><dd>{{ m.owner }}</dd></ng-container>
            <ng-container *ngIf="m.date"><dt>Approx. date</dt><dd>{{ m.date }}</dd></ng-container>
            <ng-container *ngIf="m.marker"><dt>How to recognise it</dt><dd>{{ m.marker }}</dd></ng-container>
            <ng-container *ngIf="m.why"><dt>Why it matters</dt><dd>{{ m.why }}</dd></ng-container>
          </dl>
        </div>
      </ng-container>
      <ng-template #noneMissing>
        <div class="empty" style="padding:28px 10px">No custom documents added.</div>
      </ng-template>
    </div>
  </section>
</div>
